import { supabaseClient } from "supabase";

export const copyImage = async (
  sourceFileName: string,
  fileName: string,
  bucketName: string,
  folder: string
): Promise<string | null> => {
  const filePath = `${folder}/${fileName}`;

  const sourceShortName = sourceFileName.substring(
    sourceFileName.indexOf("/events/") + "/events/".length
  );

  await supabaseClient.storage.from(bucketName).copy(sourceShortName, filePath);

  const { data } = supabaseClient.storage
    .from(bucketName)
    .getPublicUrl(filePath);

  return data!.publicUrl;
};
